$(document).ready(function () {
  $(".collapse-tabs .tab").on("click", function () {
    let index = $(this).index();

    $(".collapse-tabs .tab").removeClass("active");
    $(this).addClass("active");

    $(".collapse-tabs .tab-image").removeClass("active");
    $(".collapse-tabs .tab-image").eq(index).addClass("active");
  });
});
